module.exports = __webpack_public_path__ + "static/onboarding_banner_h5.c713c052.jpg";